module.exports = __webpack_public_path__ + "static/media/settings.af4326ed.svg";